import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Container, Col, Row, Carousel, Card } from "react-bootstrap";
import cr1 from "../../Media/cr1.png";
import cr2 from "../../Media/cr2.png";
import pathology from "../../Media/pathology.png";
import { Link } from "react-router-dom";
import "../Home/home.css";

const HomeSlider = () => {
  const [slider, setSlider] = useState();

  useEffect(() => {
    fetch("https://www.api-care-box.click/api/v1/slider_image/")
      .then((res) => res.json())
      .then((data) => {
        //console.log(data);
        setSlider(data);
      });
  }, []);

  return (
    <section>
      <Container>
        <Row>
          <Col md={12} lg={8} className="shadow-lg bg-white rounded my-2">
            <Carousel controls={false}>
              <Carousel.Item interval={2000}>
                <img className="d-block w-100" alt="..." src={cr1} />
              </Carousel.Item>
              <Carousel.Item interval={2000}>
                <img className="d-block w-100" alt="..." src={cr2} />
              </Carousel.Item>

              {/* {slider && slider.map((slider) => (
                <Carousel.Item
                  interval={3000}
                >
                  <img
                    className="inline-block w-100 rounded"
                    style={{ height: "360px", margin:"10px 0" }}
                    src={slider.sliderimage}
                    key={slider.id}
                    alt=""
                  />
                </Carousel.Item>
              ))} */}
            </Carousel>
          </Col>

          <Col md={12} lg={4} className="my-2">
            <Card className="shadow-lg bg-white rounded text-center book_card">
              <Card.Img className="book_img" variant="top" src={pathology} />
              <Card.Body>
                <Card.Text className="book_text">
                  We provide the best quality pathology service at your
                  doorstep.
                </Card.Text>
                <Link to="/availabletests">
                  <Button
                    className="m-4 p-2"
                    style={{
                      backgroundColor: "#CC0A61",
                      border: "1px solid #CC0A61",
                      fontFamily: "poppins",
                    }}
                  >
                    Book Pathology Online
                  </Button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HomeSlider;
